import styled from "styled-components"

export interface StyledModalSectionProps {
  accent_color: string
}

export interface StyledBackgroundImageProps {
  background_image: string
}

export const StyledModalSectionOuter = styled.div`
  position: relative;

  &:nth-of-type(1) {
    margin-top: 0;
  }
`
export const StyledModalSection = styled.div`
  width: 100%;
  padding: 0 32px 56px 32px;

  padding-top: 70px;
  margin-top: -70px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 0 24px 54px 24px;
  }
`
export const StyledModalSectionLabel = styled.p<StyledModalSectionProps>`
  width: 100%;
  ${(props) => props.theme.mixins.bold}
  color: ${(props) => props.theme.colors.darkGrey};
  max-width: 100%;
  margin: 0;
  border-top: 4px solid ${(props) => props.theme.colors.darkGrey};
  ${(props) =>
    props.accent_color === "undergraduate" &&
    `border-color: ${props.theme.colors.undergraduate};`}
  ${(props) =>
    props.accent_color === "masters" &&
    `border-color: ${props.theme.colors.masters};`}
  ${(props) =>
    props.accent_color === "mba" && `border-color: ${props.theme.colors.mba};`}
  ${(props) =>
    props.accent_color === "executive" &&
    `border-color: ${props.theme.colors.executive};`}
  ${(props) =>
    props.accent_color === "doctorate" &&
    `border-color: ${props.theme.colors.doctorate};`}
  padding-top: 8px;
  position: relative;
`
export const StyledModalSectionTitle = styled.p`
  width: 100%;
  ${(props) => props.theme.mixins.h2}
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 8px 0 0 0;
`
export const StyledModalSectionContent = styled.div`
  width: 100%;
`
export const StyledSectionBackgroundImage = styled.div<StyledBackgroundImageProps>`
  width: 100%;
  height: calc(100% - 70px);
  top: 72px;
  pointer-events: none;
  left: 0;
  position: absolute;
  ${(props) =>
    props.background_image &&
    `
      background-image: url('${props.background_image}');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      background-clip: padding-box;
  `}
`
